import { defineStore } from 'pinia';
import { IResource } from '@torim-app/types';
import { ResourcesApi } from '@app/api/admin';

interface IAdminResourcesStore {
  resources: IResource[];
  loaded: boolean;
}

export const useAdminResourcesStore = defineStore('admin-resources', {
  state: (): IAdminResourcesStore => ({
    resources: [],
    loaded: false,
  }),

  getters: {
    getResources: (state): IResource[] => state.resources,
  },

  actions: {
    async fetchResources(): Promise<void> {
      this.resources = await ResourcesApi.getResources();
      this.loaded = true;
    },

    async saveResource(resource: Partial<IResource>): Promise<IResource> {
      const saved = await ResourcesApi.upsertResource(resource);
      await this.fetchResources();
      return saved;
    },

    async removeResource(resourceId: string): Promise<void> {
      await ResourcesApi.deleteResource(resourceId);
      await this.fetchResources();
    },
  },
});
